import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { HardHat, CalendarClock, CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

export default function ExtendItem() {
  const [params] = useSearchParams();
  const type = params.get("type") || "";
  const id = params.get("id") || "";
  const token = params.get("token") || "";
  const [state, setState] = useState("idle"); // idle | loading | ok | error
  const [message, setMessage] = useState("");

  const extend = async () => {
    setState("loading");
    try {
      const { data } = await api.post("/items/verleng-token", { type, id, token });
      setState("ok"); setMessage(data.message || "Verlengd met 1 maand.");
    } catch (err) {
      setState("error"); setMessage(formatApiErrorDetail(err.response?.data?.detail) || "Verlengen mislukt.");
    }
  };

  const label = type === "offerte" ? "offerteaanvraag" : "opdracht";

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-md text-center" data-testid="extend-item-page">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-8 h-8 bg-orange-500 flex items-center justify-center rounded-sm"><HardHat className="w-4 h-4 text-white" /></div>
          <span className="font-display font-extrabold">Work4you</span>
        </Link>
        {state === "ok" ? (
          <div data-testid="extend-success">
            <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5"><CheckCircle2 className="w-7 h-7 text-green-600" /></div>
            <h1 className="font-display text-2xl font-extrabold text-slate-950 mb-3">Verlengd</h1>
            <p className="text-sm text-slate-600">{message} Je {label} blijft nog 1 maand staan.</p>
          </div>
        ) : state === "error" ? (
          <div data-testid="extend-error">
            <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-5"><AlertCircle className="w-7 h-7 text-red-600" /></div>
            <h1 className="font-display text-2xl font-extrabold text-slate-950 mb-3">Verlengen mislukt</h1>
            <p className="text-sm text-slate-600">{message}</p>
          </div>
        ) : (
          <div>
            <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-5"><CalendarClock className="w-7 h-7 text-orange-600" /></div>
            <h1 className="font-display text-2xl font-extrabold text-slate-950 mb-3">Laat je {label} staan</h1>
            <p className="text-sm text-slate-600 mb-6">Verleng je {label} met 1 maand zodat ze zichtbaar blijft.</p>
            <button data-testid="extend-confirm-btn" onClick={extend} disabled={state === "loading" || !id || !token}
              className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white rounded-sm font-bold px-6 py-2.5 disabled:opacity-60">
              {state === "loading" && <Loader2 className="w-4 h-4 animate-spin" />} Verleng met 1 maand
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
